/**
 * The IDL of the module.
 *
 * @module
 */
/** The IDL of the module. */
export const idl = {
  module_id: "0x1::bcs",
  doc: "Utility for converting a Move value to its binary representation in BCS (Binary Canonical\nSerialization). BCS is the binary encoding for Move resources and other non-module values\npublished on-chain. See https://github.com/aptos/bcs#binary-canonical-serialization-bcs for more\ndetails on BCS.",
  functions: [],
  structs: [],
  errors: {},
} as const;
